import PosthogService from '~/services/posthog/PosthogService';
import { REDESIGN_SIGNUP_DESIGN_DATE } from '~/services/posthog/events';

/**
 * Fires when the user submits the Office Details step (Step 2).
 * Event: dental_portal:office_signup:general_office_info_submitted
 */
export function fireGeneralOfficeInfoSubmitted(): void {
  PosthogService.getInstance().track('dental_portal:office_signup:general_office_info_submitted', {
    design_date: REDESIGN_SIGNUP_DESIGN_DATE,
  });
}
